import React from 'react';
import {
  any,
  func,
  bool,
  number,
} from 'prop-types';

const RenderItem = ({
  item,
  index,
  isLast,
  renderItem,
  ItemSeparatorComponent,
}) => {
  if (ItemSeparatorComponent && !isLast) {
    return (
      <div className="render-item">
        {renderItem({
          item,
          index,
        })}
        <ItemSeparatorComponent />
      </div>
    );
  }
  return (
    <div className="render-last">
      {renderItem({
        item,
        index,
      })}
    </div>
  );
};

RenderItem.propTypes = {
  item: any.isRequired,
  index: number.isRequired,
  isLast: bool.isRequired,
  renderItem: func.isRequired,
  ItemSeparatorComponent: func,
};

RenderItem.defaultProps = {
  ItemSeparatorComponent: null,
};

export default RenderItem;
